/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import { Col, Row, UncontrolledTooltip } from "reactstrap";
import zoomInIcon from "../../assets/zoom-in.svg";
import zoomOutIcon from "../../assets/zoom-out.svg";
import moment from "moment";
import ImageMapper from "../../species/ImageMapper/imageMapper";
import TrackResultSampleDisplay from "../trackResultSampleDisplay/trackResultSampleDisplay";

import {
  fetchBuilding,
  fetchFloors,
  fetchFloorPlan,
  fetchLocationResultsTrackingData,
  saveSample,
  updateSample,
  deleteSample,
} from "../../actions";
import "../../components/ResultTracking/resultTracking.css";
import "../../species/SpeciesDensityTracking/densityTracking.css";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer } from "react-toastify";

const initialState = {
  name: "floor-map",
  width: 0,
  height: 0,
  clickedFloorArea: undefined,
  zoomInEnabled: true,
  zoomOutEnabled: true,
};

class SpeciesDensityTracking extends React.Component {
  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.state = initialState;
    if (
      props.resultsData !== "undefined" &&
      props.resultsData.data !== undefined &&
      props.resultsData.data.length > 0
    ) {
      this.fetchLocationAreas(props.resultsData);
    }
    this.floorElement = (element) => {
      if (element) {
        let floorDim = element.container.getBoundingClientRect();
        this.setState({
          leftFloor: floorDim.left,
          topFloor: floorDim.top,
        });
      }
    };
  }

  componentWillMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let width = window.innerWidth * 0.66;
    this.setState({
      width: 865,
      height: 550,
      zoomOutEnabled: false,
      zoomInEnabled: width < 2000 ? true : false,
    });
  }

  resetFloorData = () => {
    this.setState(floorInitialState);
    this.resetSampleData();
  };

  clicked = (area) => {
    if (area.type === "location") {
    } else if (area.type === "sample") {
      this.setState((prevState) => ({
        hoveredArea: area,
        typeOfSample: area.sampleObject.type_of_samples,
        typeofAnalysis: area.sampleObject.type_of_analysis,
        locationId:
          area.sampleObject.location +
          (area.sampleObject.unit ? `_${area.sampleObject.unit.unit_id}` : ""),
        dateAndTime: moment(new Date(area.sampleObject.date_time)).format(
          "MMMM D, YYYY HH:mm"
        ),
        resultST: area.sampleObject.result.sequence_type,
        resultCT: area.sampleObject.result.complex_type,
        resultNovel: area.sampleObject.result.novel_type,
      }));
      this.toggleResultModal();
    } else if (area.type === "result_tracking") {
      this.setState((prevState) => ({
        resultCT: area.ctResult.complex_type,
      }));
      this.toggleResultModal();
    } else if (area.type === "result_tracking_room") {
      this.setState({
        roomName: area.name,
        clickedFloorArea: area,
      });
    }
  };

  enterArea(area) {
    if (area.type == "location") {
      this.setState({
        hoveredArea: area,
        hoveredType: "location",
        hoveredName: area.locationObject.room.room_name,
      });
    } else if (area.type === "result_tracking") {
      this.setState({
        hoveredArea: area,
        hoveredType: "location",
        hoveredName: "CT " + area.ctResult.complex_type,
      });
    }
  }

  leaveArea(area) {
    if (area.type == "location") {
      this.setState({
        hoveredArea: null,
        hoveredType: null,
        hoveredName: null,
      });
    }
  }

  getTipPosition(area) {
    if (area && area.locationObject) {
      let room_id = area.locationObject.room.room_id;
      let typeOfArea = "Floor";
      let style = {
        top: `${this.state["top" + typeOfArea] + area.center[1]}px`,
        left: `${
          this.state["left" + typeOfArea] +
          area.center[0] -
          this.state.width * 0.075
        }px`,
      };

      return style;
    }
  }

  getLinesMapping = (trackingLinesdata) => {
    let trackingAreas = [];
    for (let key in trackingLinesdata) {
      let coords_list = trackingLinesdata[key];
      for (let index = 0; index < coords_list.length - 1; ++index) {
        let coords = coords_list[index].concat(coords_list[index + 1]);
        trackingAreas.push({
          shape: "line",
          coords: coords,
          type: "result_tracking_line",
          strokeColor: this.props.ctColorMapping[key],
          preFillColor: "#f1f2f869",
        });
      }
    }
    return trackingAreas;
  };

  getCTResultMapping = (
    ct_result_list,
    coords,
    locationObject,
    areas,
    trackingLinesdata
  ) => {
    if (coords.length > 4) {
      coords = locationObject.rect_coordinates.split(",").map(Number);
    }
    let [x1, x2] =
      coords[0] < coords[2] ? [coords[0], coords[2]] : [coords[2], coords[0]];
    let [y1, y2] =
      coords[1] < coords[3] ? [coords[1], coords[3]] : [coords[3], coords[1]];
    let [width, height] = [x2 - x1, y2 - y1];

    let len = 25;
    let mar = 5;
    let [samples_width, no_samples_height] = [
      ~~(width / (len + mar)) - 1,
      ~~(height / (len + mar)) - 1,
    ];

    ct_result_list.map((ctResult, i) => {
      let horiz_count = ~~(i % samples_width);
      let vert_count = ~~(i / samples_width);
      let coords = [
        x1 + mar * (horiz_count + 1) + len * horiz_count,
        y1 + mar * (vert_count + 1) + len * vert_count,
        x1 + mar * (horiz_count + 1) + len * (horiz_count + 1),
        y1 + mar * (vert_count + 1) + len * (vert_count + 1),
      ];
      ctResult.samples.map((sample) => {
        sample["preFillColor"] =
          this.props.ctColorMapping[ctResult.complex_type];
      });
      areas.push({
        shape: "rect",
        coords: coords,
        preFillColor: this.props.ctColorMapping[ctResult.complex_type],
        ctResult: ctResult,
        type: "result_tracking",
        locationObject: locationObject,
        text: ctResult.complex_type__count,
      });
      let room_id = locationObject.room.room_id;
      if (trackingLinesdata.hasOwnProperty(ctResult.complex_type)) {
        trackingLinesdata[ctResult.complex_type].push([
          coords[0] + len / 2,
          coords[1] + len / 2,
        ]);
      }
    });
    return areas, trackingLinesdata;
  };

  getLocationMapping = (locationData) => {
    let areas = [];
    let sampleMappingAreas = [];
    let trackingLinesdata = {};
    Object.keys(this.props.ctColorMapping).forEach((ct) => {
      if (this.props.ctCheckboxMapping[ct]) {
        trackingLinesdata[ct] = [];
      }
    });
    let [floor_map, floor_name, building_name, floor_plan_width] = "";

    let floor_data = locationData.floor_data;

    floor_map = floor_data.floor_plan;
    floor_name = floor_data.floor_name;
    floor_plan_width = floor_data.floor_plan_width;
    building_name = floor_data.building.building_name;

    let locationMapData = locationData.data;

    locationMapData.map((locationObject, i) => {
      let coords = locationObject.coordinates.split(",").map(Number);
      let ct_result_list = locationObject.complex_type;
      let room_id = locationObject.room.room_id;
      let shape = "";
      if (coords.length > 4) {
        shape = "poly";
      } else {
        shape = "room";
      }
      let sample_areas = [];
      if (ct_result_list.length > 0) {
        sample_areas,
          (trackingLinesdata = this.getCTResultMapping(
            ct_result_list,
            coords,
            locationObject,
            sample_areas,
            trackingLinesdata
          ));
      }
      areas.push({
        name: locationObject.room.room_name,
        sample_areas: sample_areas,
        shape: shape,
        coords: coords,
        locationObject: locationObject,
        type: "result_tracking_room",
        strokeColor: "#9398c7",
        preFillColor: "#f1f2f869",
        clickedFillColor: "#dfe2f780",
        clickedStrokeColor: "#143d8d",
        text: locationObject.room.room_name,
        fillColor: "#ebfcfc",
      });
      sampleMappingAreas.push(...sample_areas);
      areas.push(...sample_areas);
    });

    let trackingAreas = this.getLinesMapping(trackingLinesdata);
    areas.push(...trackingAreas);
    areas.push(...sampleMappingAreas);

    return [areas, floor_map, floor_name, floor_plan_width, building_name];
  };

  fetchLocationAreas = (locations_data) => {
    let [areas, floor_plan, floor_name, floor_plan_width, building_name] =
      this.getLocationMapping(locations_data);
    this.state = {
      name: "floor-map",
      width: 0,
      height: 0,
      areas: [...areas],
      floor_plan: floor_plan,
      floor_name: floor_name,
      floor_plan_width: floor_plan_width,
      building_name: building_name,
      key: 1,
      clickedFloorArea: undefined,
    };
  };

  fetchUpdatedLocationAreas = (locations_data) => {
    let [areas, floor_plan, floor_name, building_name] =
      this.getLocationMapping(locations_data);
    this.setState = {
      areas: [...areas],
      floor_plan: floor_plan,
      floor_name: floor_name,
      building_name: building_name,
      key: this.state.key + 1,
    };
  };

  zoomIn = () => {
    let width = this.state.width;
    if (width < 2000) {
      width = width + (2 / 100) * width;
      this.setState({
        width: width,
        zoomOutEnabled: true,
        zoomInEnabled: width < 2000 ? true : false,
      });
      
        //To increase each coordinate value to keep the mapping in place
        if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
          this.state.areas.forEach((item, index) =>{
            let new_coords = []
            let new_item 
            item['coords'].forEach((item) => {
                new_item = item + ((2 / 100) * item)
                new_coords.push(new_item)
            })
            this.state.areas[index]['coords'] = new_coords
            let new_areas = this.state.areas
            new_areas.coords = new_coords
        })
        this.setState({areas : this.state.areas})
      }
    }
  };

  zoomOut = () => {
    let actualwidth = window.innerWidth * 0.66;
    let width = this.state.width;
    if (width > actualwidth) {
      width = width - (2 / 100) * width;
      this.setState({
        width: width,
        zoomInEnabled: true,
        zoomOutEnabled: width > actualwidth,
      });
      
        //To decrease each coordinate value to keep the mapping in place
        if(!localStorage.getItem('guest') && !localStorage.getItem('species')){
          this.state.areas.forEach((item, index) =>{
            let new_coords = []
            let new_item 
            item['coords'].forEach((item) => {
                new_item = item - ((2 / 100) * item)
                new_coords.push(new_item)
            })
            this.state.areas[index]['coords'] = new_coords
            let new_areas = this.state.areas
            new_areas.coords = new_coords
        })
        this.setState({areas : this.state.areas})
      }
    }
  };

  render() {
    return (
      <div>
        <div style={{ position: "relative" }}>
          <Row className="d-flex justify-content-end">
            <Col sm={3} md={3} lg={3} className="scale-text">
              Percentage of species found
            </Col>
            <Col sm={3} md={3} lg={3}></Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col sm={2} md={2} lg={1} className="scale-text">
            </Col>
            <Col sm={1} md={1} lg={1}>
              <span className="box yellow"></span>
              <span className="scale-text">0-9%</span>
            </Col>
            <Col sm={1} md={1} lg={1}>
              <span className="box light-green"></span>
              <span className="scale-text">10-24%</span>
            </Col>
            <Col sm={1} md={1} lg={1}>
              <span className="scale-text">25-49%</span>
              <span className="box green"></span>
            </Col>
            <Col sm={1} md={1} lg={1}>
              <span className="scale-text">50-74%</span>
              <span className="box blue"></span>
            </Col>
            <Col sm={1} md={1} lg={1}>
              <span className="scale-text">75-99%</span>
              <span className="box purlple"></span>
            </Col>
            <Col sm={1} md={1} lg={1}>
              <span className="box red"></span>
              <span className="scale-text">99% +</span>
            </Col>
            <Col sm={5} md={5} lg={5}></Col>
            <Col sm={1} md={1} lg={1} className="zoom-borders">
              <div
                className={
                  "border-icons border-icons-left" +
                  (this.state.zoomInEnabled ? "" : " border-icons-disable")
                }
                id="ZoomIn"
                onClick={this.zoomIn}
              >
                <img id="ZoomIn" src={zoomInIcon} alt="" />
                <UncontrolledTooltip placement="top" target="ZoomIn">
                  Zoom In
                </UncontrolledTooltip>
              </div>
              <div
                className={
                  "border-icons border-icons-right" +
                  (this.state.zoomOutEnabled ? "" : " border-icons-disable")
                }
                id="ZoomOut"
                onClick={this.zoomOut}
              >
                <img src={zoomOutIcon} alt="" />
                <UncontrolledTooltip placement="top" target="ZoomOut">
                  Zoom Out
                </UncontrolledTooltip>
              </div>
            </Col>
          </Row>
          <Row className="d-flex justify-content-end"></Row>
          {this.state.clickedFloorArea ? (
            <TrackResultSampleDisplay
              roomDetails={this.state.clickedFloorArea}
              roomName={this.state.roomName}
            ></TrackResultSampleDisplay>
          ) : null}
          {this.state.areas && this.state.floor_plan ? (
            <div className="floorplan-image">
              <Row className="elements">
                <Col>
                  <ImageMapper
                    ref={this.floorElement}
                    id="map"
                    src={this.state.floor_plan}
                    key={"floorplan" + this.props.key}
                    map={{ name: this.state.name, areas: this.state.areas }}
                    imgWidth={this.state.floor_plan_width}
                    width={this.state.width}
                    onClick={(area) => this.clicked(area)}
                    onMouseEnter={(area) => this.enterArea(area)}
                    onMouseLeave={(area) => this.leaveArea(area)}
                    currentlyClickedArea={this.state.clickedFloorArea}
                  />
                </Col>
              </Row>
            </div>
          ) : null}
        </div>
        {this.state.hoveredType ? (
          <div
            className="tooltips"
            style={{ ...this.getTipPosition(this.state.hoveredArea) }}
          >
            {this.state.hoveredName}
          </div>
        ) : null}
        <ToastContainer autoClose={3000} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locationAreas: state.location_data.locationData,
    buildingList: state.floor_data.buildingsList,
    floorsList: state.floor_data.floorsList,
  };
};

export default connect(mapStateToProps, {
  fetchLocationResultsTrackingData,
  fetchBuilding,
  fetchFloors,
  fetchFloorPlan,
  saveSample,
  updateSample,
  deleteSample,
})(SpeciesDensityTracking);
